/**
 * C-1 — paylaşılan react-intl sağlayıcı. Locale'i store'dan okur, katalogları birleştirir,
 * <html lang/dir>'i locale'e göre ayarlar (RTL altyapısı). Uygulamalar hardcoded
 * <IntlProvider locale="tr"> yerine bunu kullanır → tek merkezden dil + yön.
 */
import { ReactNode, useEffect } from 'react';
import { IntlProvider } from 'react-intl';

import { directionOf, Locale, SOURCE_LOCALE } from './locales';
import { MessageCatalog, mergeCatalog } from './messages';
import { useLocaleStore } from './store';

export interface ZercodeIntlProviderProps {
  children: ReactNode;
  /** Uygulamaya özel mesaj katalogları (taban katalogla birleşir). */
  appMessages?: Partial<Record<Locale, MessageCatalog>>;
}

export function ZercodeIntlProvider({ children, appMessages }: ZercodeIntlProviderProps) {
  const locale = useLocaleStore((state) => state.locale);

  useEffect(() => {
    document.documentElement.setAttribute('lang', locale);
    document.documentElement.setAttribute('dir', directionOf(locale));
  }, [locale]);

  return (
    <IntlProvider
      locale={locale}
      // ⚠ THE SOURCE LANGUAGE, NOT THE DEFAULT ONE. This tells react-intl which language the
      // `defaultMessage` fallbacks are written in — Turkish — and it stopped being the same value as
      // DEFAULT_LOCALE when the product started opening in English.
      defaultLocale={SOURCE_LOCALE}
      messages={mergeCatalog(locale, appMessages)}
      // Eksik anahtar = bileşenin defaultMessage'ı (pilot en/tr karışık). Gürültü yapma.
      onError={() => undefined}
    >
      {children}
    </IntlProvider>
  );
}
